import React from 'react';

const Next = () => {
    return ( 
        <div className="contenedor resultado">
            <div className="resumen">
                <h5 className="titulo">Lo que sigue</h5>
                <span className="resuladospan"></span>
            </div>
            <div className="parrafo">
                <p>La etapa en la que encuentra el Proyecto fue crear el núcleo clasificador que el núcleo de la aplicación, pero se piensa integral en diferentes partes para que sea una herramienta multiplataforma. La siguiente etapa se piensa integrar el algoritmo con la API de Esri para que corra en tiempo actual, tambien con una de librería de Python se realizara algebra de mapas para integrar el impacto solar en los techos para la eficiencia del panel, este primer producto se desarrollara con Electrón JS, para aplicación de escritorio, donde el frontend será con React JS y el backend con Python. Por parte de investigacion está en proceso de publicación un artículo en una revista científica de grupo A de índole internacional.</p>
            </div>
        </div>
     );
}
 
export default Next;